import { gql } from '@apollo/client'

export const GET_PATH_ENROLLMENT = gql`
  query getPathEnrollment($id: ID!, $pagination: PaginationInputObject!) {
    enrollment(id: $id) {
      id
      activatedAt
      availableUntil
      lessonsProgresses {
        id
      }
      schoolProduct {
        id
        availableTimeLength
        expireDate
        title
        path {
          id
          courses(
            pagination: $pagination
            ordenation: { by: "id", direction: "asc" }
          ) {
            id
            name
            imageUrl
            kind
            courseModules(pagination: { offset: 0, limit: 1 }, main: true) {
              nodes {
                id
                courseContents {
                  nodes {
                    id
                    available
                    lesson {
                      id
                      title
                      releaseAt
                      releaseAfter
                      lockAt
                      lockAfter
                      createdAt
                      courseContentId
                      media {
                        id
                        type
                        duration
                        hostKey
                        host
                        fileExt
                        text
                        organizationUuid
                      }
                      coverImage {
                        cdnFileUrl
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export const GET_PATH_ENROLLMENT_PROGRESS_CARD = gql`
  query getPathEnrollmentProgressCard(
    $id: ID!
    $offset: Int!
    $limit: Int!
    $courseIds: [ID!]
  ) {
    enrollment(id: $id) {
      id
      progressCard {
        id
        courseProgressCards(
          pagination: { offset: $offset, limit: $limit }
          ordenation: { by: "id", direction: "asc" }
          courseIds: $courseIds
        ) {
          id
          total
          progress
          courseId
          completed
        }
      }
    }
  }
`
